import { motion } from "framer-motion";

export const ease = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 40, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

const lineVariants = { hidden: { y: "105%" }, show: { y: "0%" } };

export function MaskLine({ children, delay = 0, inView = false, className = "" }) {
  const trigger = inView
    ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0 } }
    : { initial: "hidden", animate: "show" };
  return (
    <motion.span {...trigger} className={`block overflow-hidden pb-[0.04em] ${className}`}>
      <motion.span className="block will-change-transform" variants={lineVariants} transition={{ duration: 1.1, ease, delay }}>
        {children}
      </motion.span>
    </motion.span>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`font-mono text-xs uppercase tracking-[0.3em] text-volt flex items-center gap-3 ${className}`}>
      <span className="inline-block h-px w-8 bg-[var(--volt)]" />
      {children}
    </p>
  );
}
